export const CURRENT_HOSPITAL_KEY = 'currentHospital';
export const CURRENT_HOSPITAL_EVENT = 'carenet:currentHospital';

export function getCurrentHospital() {
  return window.sessionStorage.getItem(CURRENT_HOSPITAL_KEY);
}

export function setCurrentHospital(value) {
  if (value == null || value === '') {
    if (!getCurrentHospital()) return;
    window.sessionStorage.removeItem(CURRENT_HOSPITAL_KEY);
    window.dispatchEvent(new CustomEvent(CURRENT_HOSPITAL_EVENT, { detail: null }));
    return;
  }

  const next = String(value).split('#')[0];
  if (getCurrentHospital() === next) return;

  window.sessionStorage.setItem(CURRENT_HOSPITAL_KEY, next);
  window.dispatchEvent(new CustomEvent(CURRENT_HOSPITAL_EVENT, { detail: next }));
}

export function subscribeCurrentHospital(listener) {
  const onCustom = (event) => {
    listener(event.detail ?? getCurrentHospital());
  };

  const onStorage = (event) => {
    if (event.key === CURRENT_HOSPITAL_KEY || event.key === null) {
      listener(getCurrentHospital());
    }
  };

  window.addEventListener(CURRENT_HOSPITAL_EVENT, onCustom);
  window.addEventListener('storage', onStorage);

  return () => {
    window.removeEventListener(CURRENT_HOSPITAL_EVENT, onCustom);
    window.removeEventListener('storage', onStorage);
  };
}
